import { useTheme } from '@mui/material/styles';
import { Box, SpeedDial, Typography, SpeedDialAction, SpeedDialIcon, Fab, Container, ButtonGroup, Button, useMediaQuery, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { Add as AddIcon, Search as SearchIcon } from '@mui/icons-material';
import ListLocationsComponent from '../components/ListLocationsComponent';

import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import FilterListIcon from '@mui/icons-material/FilterList';
import UploadIcon from '@mui/icons-material/Upload';
import { useUtiles } from '../../../../shared/context/utilesContext';
import ListMasiveComponent from '../components/ListMasiveComponent';
import { useNavigate } from 'react-router';
import FiltersLocationsComponent from '../components/FiltersLocationsComponent';
import { useState, useEffect } from 'react';
import TreeLocationsComponent from '../components/TreeLocationsComponent';
import { useAbility } from '../../../../shared/context/AbilityContext';

export default function ListLocationsView() {
    const theme = useTheme();
    const isMobile = useMediaQuery('(max-width: 600px)');
    const { toogleOpenSilder } = useUtiles()
    const navigate = useNavigate()

    const [view, setView] = useState('list')
    const handleView = (event, newValue) => {
        if(newValue !== null) {
            setView(newValue);
        }
    }

    const ability = useAbility();
    useEffect(() => {
        if (!ability.can('read', 'ASSETS.LOCATIONS')) {
            navigate('/')
        }
    }, [ability])

    return (
        <Container maxWidth="xl" disableGutters sx={{
            padding: '0px', margin: '0px',
        }}>
           
            <Box sx={{
                borderRadius: '10px',
                backgroundColor: theme.palette.background.paper,
                padding: '10px 20px',
                position: 'relative'
            }}>
                
                <Typography variant="h6" sx={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    fontSize: '20px',
                }}>
                    Lista de Ubicaciones
                </Typography>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <ToggleButtonGroup
                        value={view}
                        onChange={handleView}
                        color="primary"
                        variant="outlined"
                        exclusive
                        size="small"
                    >
                        <ToggleButton value={"list"} >
                             <FormatListBulletedIcon sx={{mr: 1}} />  Lista
                        </ToggleButton>
                        <ToggleButton value={"tree"} >
                            <AccountTreeIcon sx={{mr: 1}} /> Arbol
                        </ToggleButton>
                    </ToggleButtonGroup>

                    {!isMobile && (
                        <ButtonGroup>
                            <Button startIcon={<FilterListIcon />} onClick={() => toogleOpenSilder(<FiltersLocationsComponent type_asset="locations" />, 400, 'Filtros')}>
                                Filtros
                        </Button>
                       {ability.can('create', 'ASSETS.LOCATIONS') && <Button startIcon={<UploadIcon />} onClick={() => toogleOpenSilder(<ListMasiveComponent />, 600, 'Cargar Masivo')}>
                            Importar
                        </Button>}
                    </ButtonGroup>)}

                    {isMobile && (
                        <Button startIcon={<FilterListIcon />} onClick={() => toogleOpenSilder(<FiltersLocationsComponent type_asset="locations" />, 600, 'Filtros')} variant="outlined">
                            Filtros
                        </Button>
                    )} 
                </Box>

                {view === 'list' && (
                    <ListLocationsComponent />
                )}
                {view === 'tree' && (
                    <TreeLocationsComponent />
                )}


                {/* Opción 2: Alternativa - SpeedDial con comportamiento de botón único */}
                {ability.can('create', 'ASSETS.LOCATIONS') && <SpeedDial
                    ariaLabel="Add"
                    sx={{ position: 'absolute', bottom: isMobile ? 80 : 30, right: 8 }}
                    icon={<AddIcon />}
                    direction="right"
                    openIcon={<AddIcon />}
                    onClick={() => navigate('/activos/ubicaciones/crear')}
                />}
            </Box>
        </Container>
    )
}